export default __webpack_public_path__ + "static/media/medal.4ca498f4.png";